// styles
import styles from "./Library.module.scss";

// blocks
import {
  ToggleBlock,
  CheckboxBlock,
  MultiSelectCheckboxBlock,
  NaicsCheckboxBlock,
  ButtonBlock,
  SelectListBlock,
  SearchInputBlock,
  ToggleBarBlock,
  FilterRelationBoxBlock,
  SBATagBlock,
  FilterFlyoutBlock,
  IconBlock,
  DialogBlock,
  RadioBlock,
  InputBlock,
  TextareaBlock,
  ComboBoxBlock,
} from "components/LibraryComponents/Blocks";

export default function LibraryPage() {
  return (
    <div className={styles["library-root"]}>
      <h1 className={styles["heading"]}>SBS Component Library</h1>
      <ToggleBlock />
      <CheckboxBlock />
      <MultiSelectCheckboxBlock />
      <NaicsCheckboxBlock />
      <SelectListBlock />
      <ButtonBlock />
      <FilterFlyoutBlock />
      <RadioBlock />
      <SearchInputBlock />
      <ToggleBarBlock />
      <FilterRelationBoxBlock />
      <SBATagBlock />
      <IconBlock />
      <DialogBlock />
      <InputBlock />
      <TextareaBlock />
      <ComboBoxBlock />
    </div>
  );
}
